import { RoleName } from "@/api/users-types";
import { StoryConfigRevision } from "@/components/story-configs/StoryConfigRevision";
import { StoryConfigRevisionList } from "@/components/story-configs/StoryConfigRevisionList";
import { ApiErrorAlert } from "@/components/ui/ApiErrorAlert";
import { StoryConfigBreadcrumbs } from "@/components/ui/breadcrumbs/StoryConfigBreadcrumbs";
import { TimestampBreadcrumbs } from "@/components/ui/breadcrumbs/TimestampBreadcrumbs";
import { BoxLoader } from "@/components/ui/loaders";
import { NoPermissions } from "@/components/ui/NoPermissions";
import { useHasRole } from "@/hooks/use-has-role";
import { useStoryConfigById } from "@/queries/story-configs/use-story-config-by-id";
import { Stack } from "@mui/material";
import { useParams } from "react-router";

export function StoryConfigPage() {
  const { id, revisionNumber: revisionNumberParam } = useParams();
  const revisionNumber = revisionNumberParam
    ? parseInt(revisionNumberParam, 10)
    : undefined;

  const canView = useHasRole([
    RoleName.promptEngineer,
    RoleName.episodeManager,
  ]);

  return (
    <>
      {canView ? (
        <Stack gap={2} mb={2}>
          <StoryConfigDetails id={id} />
          <StoryConfigRevision id={id} revisionNumber={revisionNumber} />
          <StoryConfigRevisionList id={id} />
        </Stack>
      ) : (
        <NoPermissions />
      )}
    </>
  );
}

function StoryConfigDetails({ id }: { id: string | undefined }) {
  const { data, error, isLoading } = useStoryConfigById(id);

  return (
    <Stack gap={2}>
      <BoxLoader height={300} isLoading={isLoading} />
      <ApiErrorAlert error={error} />
      {data && (
        <>
          <StoryConfigBreadcrumbs {...data} />
          <TimestampBreadcrumbs {...data} />
        </>
      )}
    </Stack>
  );
}
